/**
 * Determines the visitor's traffic source for outbound URL parity.
 *
 * @param urlString - the URL (with query string) to parse
 */
const getTrafficSource = (urlString: string): string => {
  const queryString = urlString.includes('?')
    ? urlString.split('?')[1]
    : urlString;

  const urlParams = new URLSearchParams(queryString);

  let source = (
    urlParams.has('utmCap') || urlParams.has('utm_cap')
      ? (urlParams.get('utmCap') ?? urlParams.get('utm_cap'))
      : 'organic'
  )?.toLowerCase();

  if (source && ['search', 'social'].includes(source)) {
    source = `paid ${source}`;
  }

  return source ?? '';
};

export default getTrafficSource;
